import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import Customform from "../../../ui/custom-form";
import CustomInput from "../../../ui/custom-input";
import {
  AddEmployedata,
  fetchCameragrouplistingApi,
  fetchCameraTypeApi,
  GetEmployeeDetailApi,
  UpdateEmployedata,
} from "../../../api/api";
import { PulseLoader } from "react-spinners";
import CustomButton from "../../../ui/custom-button";
import axios from "axios";

function AddEmploye() {
  const dispatch = useDispatch();
  const [cameraTypeInfo, setCameraTypeInfo] = useState([]);
  // const [cameraGroupData, setCameraGroupData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [empId, setEmpid] = useState("");
  const [inputData, setInputData] = useState({
    employee_name: "",
    // camera_group_id: "",
  });
  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );

  useEffect(() => {
    if (data) {
      fetchEmployeeData();
    }
  }, [data]);

  // const getCameragroup = async () => {
  //   try {
  //     const res = await fetchCameragrouplistingApi(
  //       "",
  //       user_id,
  //       organization_id
  //     );
  //     if (res?.data?.status === true) {
  //       setCameraGroupData(res?.data?.data);
  //     }
  //   } catch (error) {
  //     //console.log("error", error);
  //   }
  // };

  const fetchEmployeeData = async () => {
    try {
      const res = await GetEmployeeDetailApi(data, user_id, organization_id);
      const details = res?.data?.data;
      //console.log("details", details);

      if (res?.data?.status === true) {
        // const groupId = String(details?.camera_grp_id || "");

        // Set employee info
        setInputData({
          employee_name: details?.employee_name || "",
          // camera_group_id: groupId,
        });
        setEmpid(details?._id);
        // Set image preview
        if (details?.employee_image) {
          setImagePreview(
            `https://visionemptrack.greymatterz.com/${details.employee_image}`
          );
        }

        // Check if camera group from details exists in dropdown list
        // const exists = cameraGroupData.find(
        //   (grp) => String(grp._id) === groupId
        // );

        // // If not found, add it manually so it appears in dropdown
        // if (!exists && groupId) {
        //   setCameraGroupData((prev) => [
        //     ...prev,
        //     {
        //       _id: groupId,
        //       camera_grp_name: "(Unavailable Group)",
        //     },
        //   ]);
        // }
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image_url") {
      if (files?.length > 0) {
        const file = files[0];
        const preview = URL.createObjectURL(file);
        setImagePreview(preview);
        setImageFile(file);
      }
    } else {
      setInputData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("employee_name", inputData.employee_name);
      // formData.append("camera_grp_id", inputData.camera_group_id);
      if (data) {
        formData.append("employee_id", empId);
      }
      formData.append("user_id", user_id);
      formData.append("organization_id", organization_id);
      if (imageFile) {
        // New image uploaded
        formData.append("employee_image", imageFile);
      } else if (imagePreview && imagePreview.includes("attendance_photos/")) {
        // Use the old image path from preview if not uploading a new one
        const imageResponse = await fetch(imagePreview);
        const blob = await imageResponse.blob();
        //console.log("blob", blob);
        const file = new File([blob], "existing-image.jpg", {
          type: blob.type,
        });
        //console.log("file", file);
        formData.append("employee_image", file);
      }

      if (data) {
        const res = await UpdateEmployedata(formData, data);
        if (res?.data?.status === true) {
          setLoading(false);
          handleClose();
        }
      } else {
        const res = await axios.post(
          "https://us2.sourcesoftsolutions.com:8048/employees",
          formData
        );

        AddEmployedata(formData);
        if (res?.data?.status === true) {
          setLoading(false);
          handleClose();
        }
      }
    } catch (err) {
      console.error("Failed to submit employee data", err);
      setLoading(false);
    }
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        <h4 className="m-0">{data ? "Edit Employee" : "Add Employee"}</h4>
        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4">
        <Customform onSubmit={handleSubmit}>
          <div className="col-12">
            <label className="form-label">Employee Name</label>
            <CustomInput
              name="employee_name"
              placeholder="Enter Employee Name"
              value={inputData.employee_name}
              onChange={handleChange}
            />
          </div>

          {/* <div className="col-12 mt-3">
            <label className="form-label">Camera Group Name</label>
            <select
              name="camera_group_id"
              className="form-select"
              value={inputData.camera_group_id}
              onChange={handleChange}
            >
              <option value="">Select Camera Group</option>
              {cameraGroupData?.map((ele) => (
                <option key={ele?._id} value={ele._id}>
                  {ele?.camera_grp_name || "Unnamed Group"}
                </option>
              ))}
            </select>
          </div> */}

          <div className="col-12 mt-3">
            <label className="form-label">Upload Employee Image</label>
            <input
              type="file"
              accept="image/*"
              name="image_url"
              className="form-control"
              onChange={handleChange}
            />
          </div>

          {imagePreview && (
            <div className="col-12 mt-3">
              <label className="form-label">Image Preview</label>
              <img
                src={imagePreview}
                alt="Preview"
                className="img-thumbnail"
                style={{ width: "200px", height: "auto" }}
              />
            </div>
          )}

          <div className="bottomBtn d-flex justify-content-between mt-4">
            <button
              className="btn btn-outline-secondary px-4"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>
            {loading ? (
              <CustomButton type="submit" className="btnSubmit px-4 py-2">
                <PulseLoader color="#fff" />
              </CustomButton>
            ) : (
              <button className="btnSubmit px-4 py-2" type="submit">
                {data ? "Update" : "Submit"}
              </button>
            )}
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddEmploye;
